import React from 'react';

import {ChiefLogo} from 'src/svgs/chiefLogo';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type BenefitCtaProps = any;

export const BenefitCta: React.FC<BenefitCtaProps> = (props: BenefitCtaProps) => {
  return (
    <section data-module="banner-icon-cta" key={props.block._key}>
      <div className="bg-green-dark px-gutter module-spacing">
        <div className="wrapper-default grid grid-cols-4 md:grid-cols-12 lg:gap-8 items-center">
          <div className="col-span-full lg:col-span-2 mb-6 lg:mb-0 lg:flex justify-center">
            <object
              data={props.block?.icon?.asset?.url}
              className="w-7 h-7 lg:w-[88px] lg:h-[88px] stroke-white stroke-[7] lg:stroke-[2.5]"
            ></object>
          </div>

          <div className="col-span-full lg:col-span-7 lg:pl-5">
            <div className="flex flex-col lg:flex-row items-baseline lg:items-center">
              <ChiefLogo classes={'mb-2 lg:mb-0 h-[18px] lg:w-25 lg:h-5 fill-white'} />
              <span className="type-zeta lg:ml-3 text-light-gold">on {props.block.name}</span>
            </div>
            <div className="type-sm-p md:type-p mt-3 text-white">{props.block.benefitDescription}</div>
          </div>

          <div className="mt-5 lg:mt-0 col-span-full lg:col-start-10 lg:col-span-2">
            <a href={props.block.cta[0].href} target={props.block.cta[0].target} className="button">
              {props.block.cta[0].buttonText}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
